<button
  pButton
  type="button"
  icon="pi pi-download"
  label="Izvoz"
  [disabled]="(isDisabled$ | async) === false"
  (click)="executeAction()"
></button>
